<template>
  <div>
    <div class="list-item" @touchend="linkWhere(itemData.id)">
      {{itemData.title}}
      {{itemData.add_time | parseTime('{y}-{m}-{d}')}}
      <span class="more"></span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["itemData"],
  data() {
    return {};
  },
  methods: {
    linkWhere(id) {
      if (this.itemData.link != ""&&this.itemData.link) {
        window.location.href = this.itemData.link;
      } else {
        this.$emit("toLink", id);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.list-item {
  width: 100%;
  color: #194eb0;
  font-size: 30 / @rem;
  line-height: 48 / @rem;
  padding: 20 / @rem 68 / @rem 20 / @rem 20 / @rem;
  box-sizing: border-box;
  position: relative;
  border-bottom: 1px solid #d1d1d1;
  .more {
    position: absolute;
    width: 68 / @rem;
    height: 100%;
    text-align: center;
    top: 0;
    right: 0;

    background: url(/static/img/more-link.png) no-repeat center center;
    background-size: 13 / @rem 26 / @rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/listItem.vue